import { render, staticRenderFns } from "./EmailAction.vue?vue&type=template&id=36f4eae4&scoped=true"
import script from "./EmailAction.vue?vue&type=script&lang=js"
export * from "./EmailAction.vue?vue&type=script&lang=js"
import style0 from "./EmailAction.vue?vue&type=style&index=0&id=36f4eae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4eae4",
  null
  
)

export default component.exports